//colors : green red orange yellow blue purple (& all vuetify colors)
//si un paramètre n'est pas indiqué dans "params", on utilise la valeur par défaut
//le bouton apparait de la même couleur que le background, sauf si on indique "colorBtn"
//le texte du bouton apparait de la même couleur de le texte de la snackbar ("colorTxt")

const state = {
  title: "",
  txt: "No message",
  xPosition: "center",
  yPosition: "bottom",
  colorBg: "green",
  colorTxt: "white",
  colorBtn: "",
  timeout: 5000,
  show: false,
};

const mutations = {
  openSnackbar: function (state, params) {
    state.title = params.title ? params.title : "";
    state.txt = params.txt ? params.txt : "No message";
    state.xPosition = params.xPosition ? params.xPosition : "center";
    state.yPosition = params.yPosition ? params.yPosition : "bottom";
    state.colorBg = params.colorBg ? params.colorBg : "green";
    state.colorTxt = params.colorTxt ? params.colorTxt : "white";
    state.colorBtn = params.colorBtn ? params.colorBtn : state.colorBg;
    state.timeout = params.timeout ? params.timeout : 5000;
    state.show = true;
  },
};

const actions = {
  openSnackbar: ({ commit }, params) => {
    commit("openSnackbar", params);
  },
};

export default {
  state,
  mutations,
  actions,
};
